// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"85b3c96a","455":"209329e3"}[chunkId] + ".chunk.js";
};